export default __webpack_public_path__ + "static/media/delete.2d15d044.svg";